// ======================================================================
// File Name       : S3Constants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

// #7287 START
export const S3_SCRIPT_CLASS_NAME = {
  ADMIN_SCRIPT: 'adminScript',
  REPORT_SCRIPT: 'reportScript',
};
// #7287 END
